<template>
  <div class="map w-100">
    <div id="smallmap"></div>
    <div class="information">
        <div class="Introduction-title">
            {{ info.title}}
             <img v-lazy="'/images/zfxj/icon_'+info.state_star+'.png'" :key="info.state_star" height="20px" v-if="info.state_star>0"/>
            <img v-lazy="'/images/xj/icon_'+info.star+'.png'" :key="info.star" height="20px" v-else/>
            <!-- <img v-lazy="'/images/grade/'+info.exp_pic" :key="info.exp_pic" height="14px"></img> -->
        </div>
        <div class="Introduction-content">
          <div  class="hotel-star">{{info.star | formatVar('HotelStar')}}</div>
        </div>
        <div class="Introduction-content">
          <div><i class="el-icon-location-outline"></i>{{info.province_name}}省{{info.city_name}}市{{info.district_name}}{{info.address}}</div>
        </div>
        <!-- <div class="Introduction-bottom" @click="$emit('bookHotel')">
            <div class="Introduction-btn">去询价</div>
        </div> -->
        <!-- <el-tabs v-model="activeName" >
            <el-tab-pane label="附近设施" name="first"></el-tab-pane>
        </el-tabs> -->
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Surrounding',
    props:['isSide','info'],
    data() {
        return {
            activeName: 'first'
        }
    },
    mounted() {
      this.initMap();
    },
    watch: {
      info() {
        this.initMap();
      }
    },
    methods: {
      initMap() {
        // 百度地图API功能
        var map = new BMap.Map('smallmap');            // 创建Map实例
        let point = new BMap.Point(this.info.longitude, this.info.latitude);
        map.addControl(new BMap.ScaleControl());
        // map.addControl(new BMap.NavigationControl({
        //   anchor:BMAP_ANCHOR_TOP_RIGHT
        // }));   //平移缩放控件
        map.centerAndZoom(point,16);  //初始化时，即可设置中心点和地图缩放级别
        map.enableScrollWheelZoom(true);  
        let marker = new BMap.Marker(point);
        map.addOverlay(marker);
        let displayTitle = this.info.title || '';
        let star=this.info.state_star>0?this.info.state_star:this.info.star;
        map.enableDoubleClickZoom(true);
        const labelContent = `
        <div class="label-container">
          <span class="label-name">${this.info.title}</span>
          <img class="label-img" src="/images/xj/icon_${star}.png" alt="热门"  height="14px"> <!-- 标签右侧图片 -->
        </div>
      `;
        var label = new BMap.Label(labelContent, {offset: new BMap.Size(20, -10)});
                this.addLabelStyle();
        marker.setLabel(label);
              // 4. 自定义标签样式（重点：清除默认样式，设置布局）
      label.setStyle({
        border: 'none', // 清除百度地图默认边框
        padding: '0', // 清除默认内边距
        margin: '0',
        backgroundColor: 'transparent' // 清除默认背景
      });
        // // 5. 自定义标签样式（通过 CSS 类名）
        // label.setStyle({
        //   color: '#fff',
        //   backgroundColor: 'rgba(0,0,0,0.7)',
        //   padding: '5px 10px',
        //   borderRadius: '4px',
        //   fontSize: '14px',
        //   border: 'none',
        //   textAlign: 'center',
        //   whiteSpace: 'nowrap' // 防止名称换行
        // });

        // 6. 将标签添加到地图
        map.addOverlay(label);
      },
         // 动态添加标签的 CSS 样式（避免样式污染，也可写在全局样式文件）
        addLabelStyle() {
          const style = document.createElement('style');
          style.textContent = `
            .label-container {
              display: flex; /* 弹性布局：文字 + 图片横向排列 */
              align-items: center; /* 垂直居中对齐 */
              background: rgba(0, 0, 0, 0.7); /* 标签背景 */
              padding: 6px 12px;
              border-radius: 6px; /* 圆角 */
              gap: 6px; /* 文字与图片间距 */
            }
            .label-name {
              color: #fff;
              font-size: 14px;
              white-space: nowrap; /* 禁止文字换行 */
            }
 
          `;
          document.head.appendChild(style);
        },
    search() {}
    },
  }
</script>

<style scoped>
    .map{
        display: flex;
    }
    .information{
        width: 16%;
        padding: 1% 2%;
        text-align: left;
    }
    .Introduction-title{
        text-align: left;
        font-size: 24px;
        font-weight: bold;
        color: #333;
    }
    .Introduction-content{
        margin-top: 6px;
        display: flex;
    }
    .Introduction-map{
        margin-left: 6px;
    }
    .Introduction-btn{
        width: 100px;
        height: 40px;
        line-height: 40px;
        border-radius: 4px;
        font-size: 16px;
        font-weight: bold;
        text-align: center;
        background-color: var(--smtc-color-primary);
        color: #fff;
        cursor: pointer;
        float: right;
        margin-top: 16px;
    }
    .Introduction-bottom{
        overflow: hidden;
    }
</style>
<style>
    #smallmap{
        width: 80%;
        height: 1000px; 
    }
</style>